import React, { useMemo } from 'react'
import { useApiFormNodeTemplate, useApiListNodeCourse, useApiListNodeCourseCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconCopy } from '../../../../../../shared/icon/icon'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TemplateMenu } from '../../common/menu/node-actions'
import { NodeCaffeine } from '../../common/shared/node-caffeine'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { TransferCopyNodeStatus } from '../../../../../../shared/transfer/components/transfer-copy-node-status'
import { useTransferActive, useTransferComplete, useTransferNodeCopyAllowGoto } from '../../../../../../shared/transfer/hooks/transfer-data'
import { useTransferContext } from '../../../../../../shared/transfer/transfer-provider'
import { useDataContext } from '../data-context'
import { pathNodeContent } from '../../common/shared/path-node-content'

export const NodeTemplateCourse = ({ parentURL, nodeID }) => {
  const apiFormNodeTemplate = useApiFormNodeTemplate()

  const title = useMemo(() => `create course ${apiFormNodeTemplate.form.name}`, [apiFormNodeTemplate.form.name])

  const handleMatch = () => apiFormNodeTemplate.get(nodeID)

  const HeaderMenu = () => <TemplateMenu place="header" url={parentURL} node={apiFormNodeTemplate.form} />

  ///////////////

  const history = useHistory()

  const dataContext = useDataContext()
  const transferContext = useTransferContext()

  const transferID = useMemo(() => `template-to-course-${nodeID}`, [nodeID])

  const transfer = useMemo(() => transferContext.items[transferID] || null, [transferContext.items, transferID])

  const active = useTransferActive(transfer)

  useTransferComplete(transfer, () => {
    dataContext.reload()
  })

  const handleSubmit = async data => {
    if (data.destParentID === -1) {
      data.destParentID = null
    }

    const transfer = transferContext.nodeCopyTemplateToCourse(transferID, data.destName, history.location.pathname)
    transfer.start(data)
  }

  const apiListNodeCourse = useApiListNodeCourse()

  const handleGoTo = async nodeID => {
    let nodes = await apiListNodeCourse.get()
    let path = pathNodeContent(nodes, nodeID)
    history.push(path)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconCopy} text="New course" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <NodeCaffeine node={apiFormNodeTemplate.form}>
            <FormSimple disabled={active} onSubmit={handleSubmit}>
              <FormSimpleHiddenNumber name="srcNodeID" value={nodeID} required />
              <FormSimpleCategorySelectFilter
                name="destParentID"
                label="category"
                rootName="CONTENT"
                useApiListCategory={useApiListNodeCourseCategory}
                required
              />
              <FormSimpleText name="destName" label="name" defaultValue={apiFormNodeTemplate.form.name} required />
              <FormSimpleSubmitCreate text="create course" backURL={parentURL} />
            </FormSimple>

            <TransferCopyNodeStatus transfer={transfer} allowGoto gotoText="view new course" onGoTo={handleGoTo} />
          </NodeCaffeine>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
